import { AnswerModel } from 'core/models/elements/answers/answer.abstract.model';

import { pascalToCamel } from 'utils/common.util';

/**
 * @class Defines an audio answer corresponding to an audio question.
 */
export class AudioQuestionAnswerModel extends AnswerModel {
  /**
   * @constructor Creates an instance of an audio answer built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.audioFileUrl = bo.audioFileUrl;
  }

  static instantiateFromApi(data) {
    const bo = pascalToCamel(data);
    return new AudioQuestionAnswerModel(bo);
  }
}
